module.exports = __webpack_public_path__ + "static/media/time-to-stop-lol.54820517.gif";